/**
 * @module zendeskForm
 */
module.exports = function() {
    const form = document.querySelector( '.template-form .wpcf7-form' );
    const emailInput = form.querySelector( 'input[name="your-email"]' );
    const submitButton = form.querySelector( '.wpcf7-submit' );
    const responseOutput = form.querySelector( '.wpcf7-response-output' );

    const errorElement = document.createElement( 'div' );
    errorElement.className = 'input-error text-danger mt-1';
    emailInput.parentElement.appendChild( errorElement );

    const loader = document.createElement( 'div' );
    loader.className = 'form-loader d-none text-center';
    loader.innerHTML = '<div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Loading...</span></div>';
    submitButton.insertAdjacentElement( 'afterend', loader );

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const showFormMessage = ( message, status ) => {
        responseOutput.textContent = message;
        responseOutput.style.display = 'block';
        responseOutput.classList.add( 'mx-auto' );
        form.setAttribute( 'data-status', status );
        form.className = form.className.replace( /\b(init|submitting|failed|sent)\b/g, '' );
        form.classList.add( status );
    };

    const showEmailError = ( message ) => {
        errorElement.textContent = message;
        emailInput.classList.add( 'input-error text-danger mt-1' );
    };

    const clearEmailError = () => {
        errorElement.textContent = '';
        emailInput.classList.remove( 'input-error', 'text-danger', 'mt-1' );
    };

    const validateEmail = () => {
        const emailValue = emailInput.value.trim();
        if ( ! emailValue ) {
            return false;
        }
        return emailRegex.test( emailValue );
    };

    const toggleSubmitButton = () => {
        const isValid = validateEmail();
        if ( isValid ) {
            submitButton.disabled = false;
            submitButton.classList.remove( 'disabled' );
        } else {
            submitButton.disabled = true;
            submitButton.classList.add( 'disabled' );
        }
    };

    const handleSubmit = async ( e ) => {
        e.preventDefault();

        if ( ! validateEmail() ) {
            showEmailError( 'Please enter a valid email address.' );
            return;
        }

        form.setAttribute( 'data-status', 'submitting' );
        form.className = form.className.replace( /\b(init|failed|sent)\b/g, 'submitting' );

        loader.classList.remove( 'd-none' );
        submitButton.disabled = true;
        submitButton.classList.add( 'disabled' );

        try {
            const result = await fetch( '/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams( {
                    action: 'zendesk_request',
                    email: emailInput.value.trim(),
                } ),
            } );

            const data = await result.json();

            if ( data.success ) {
                emailInput.value = '';
                clearEmailError();
                showFormMessage( data.data, 'sent' );
            } else {
                showFormMessage( data.data || 'Error submitting form', 'failed' );
            }
        } catch ( err ) {
            showFormMessage( 'Error submitting form. Please try again later.', 'failed' );
        } finally {
            loader.classList.add( 'd-none' );
            toggleSubmitButton();
        }
    };

    emailInput.addEventListener( 'blur', () => {
        if ( ! validateEmail() && emailInput.value.trim() ) {
            showEmailError( 'Please enter a valid email address.' );
        } else {
            clearEmailError();
        }
        toggleSubmitButton();
    } );

    emailInput.addEventListener( 'input', () => {
        clearEmailError();
        toggleSubmitButton();
    } );

    form.addEventListener( 'submit', handleSubmit );

    form.setAttribute( 'data-status', 'init' );
    form.classList.add( 'init' );

    submitButton.disabled = false;
    submitButton.classList.remove( 'disabled' );

    if ( emailInput.value.trim() ) {
        toggleSubmitButton();
    }
}; // exports
